<template>
    <span class="title">{{t('autorizeSession.title')}}</span>
    <span class="subTitle" v-html="t('autorizeSession.subTitle')"/>
    <!-- Session Info -->
    <div class="session-info-container">
        <!-- Date -->
        <text-block-generic
        :params="{
            content: t('autorizeSession.periodLabel', {period:  moment(sessionInfo.creationDate).format('D MMMM YYYY')}),
            classes: 'capitalize'
        }"/>
        <!-- Channel -->
        <text-block-generic
        :params="{ content: t('autorizeSession.channelLabel', {channel: sessionInfo.channel}) }"/>
        <!-- Device -->
        <text-block-generic
        :params="{ content: t('autorizeSession.deviceLabel', {device: sessionInfo.device}) }"/>
        <!-- IP -->
        <text-block-generic
        :params="{ content: t('autorizeSession.ipLabel', {ip: sessionInfo.ip} ) }"/>
    </div>
    <!-- Authorize Session -->
    <button-primary
    icon="arrow-right-full"
    iconPosition="right"
    :label="t('autorizeSession.authorizeButton')"
    @clicked="emit('authorizeSession')"/>
    <!-- Warning Message -->
    <div class="warning-message" v-html="t('autorizeSession.warningMessage')" @click="emit('cancelSession')"/>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import ButtonPrimary from '@/components/generic/buttons/Primary'

/* Helper */
import moment from '@/assets/setups/moment'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['authorizeSession', 'cancelSession'])

const props = defineProps({
    sessionInfo: Object,
    isMobileApp: Boolean
})

</script>
<style lang="scss" scoped>
.title {
    width: 100%;
    margin-bottom: 8px;

    @include H3-Medium;
    color: var(--secondary-dark-3);
}

.subTitle {
    margin-bottom: 24px;

    @include H6-Regular;
    color: var(--secondary-dark-4);
}

.session-info-container {
    width: 100%;
    margin-bottom: 24px;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.button-primary {
    width: 100%;
    margin-bottom: 32px;
}

.warning-message {
    width: 100%;
    margin-bottom: 12px;

    @include H7-Regular;
    color: var(--secondary-dark-4);

    :deep(span) {
        color: var(--primary);
        font-weight: 500;
        text-decoration: underline;

        cursor: pointer;
    }
}
</style>
